export const YodleeAccountTypes = {
  BANK: 'bank',
  BILL: 'bill',
  CREDIT_CARD: 'creditCard',
  INSURANCE: 'insurance', // 1/9/2018 not supported by the backend yet, use with discretion
  INVESTMENT: 'investment',
  LOAN: 'loan',
  REWARD: 'reward',
};

export const CustomProviderIcons = {
  AMERICAN_EXPRESS:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/amex-icon@2x.png',
  AVANT:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/avant-icon@2x.png',
  BANK_OF_AMERICA:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/bofa-icon@2x.png',
  BETTERMENT:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/betterment@2x.png',
  CAPITAL_ONE:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/capital_one-icon@2x.png',
  CHARLES_SCHWAB:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/charles_schwab-icon@2x.png',
  CHASE:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/chase-icon@2x.png',
  CITIBANK:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/citibank-icon@2x.png',
  DISCOVER:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/discover-icon@2x.png',
  ETRADE:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/etrade@2x.png',
  FIDELITY:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/fidelity-icon@2x.png',
  FIDELITY_NETBENEFITS:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/fidelity_netbenefits-icon@2x.png',
  FLAGSTAR:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/flagstar_bancorp-icon@2x.png',
  GREAT_LAKES:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/great_lakes-icon@2x.png',
  HSBC: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/hsbc-icon@2x.png',
  LENDING_CLUB:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/lending-club-icon@2x.png',
  LIGHTSTREAM:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/lightstream-icon@2x.png',
  MARINER_FINANCE:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/mariner-finance-icon@2x.png',
  MOHELA:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/mohela-icon@2x.png',
  NAVIENT:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/navient-icon@2x.png',
  NELNET:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/nelnet-icon@2x.png',
  ONE_MAIN:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/one-main-icon@2x.png',
  PNC_BANK:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/pnc-icon@2x.png',
  PROSPER:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/prosper-icon@2x.png',
  QUICKEN_LOANS:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/quicken_loans-icon@2x.png',
  SOFI: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/sofi@2x.png',
  TD_BANK:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/td_bank-icon@2x.png',
  UPSTART:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/upstart-icon@2x.png',
  US_BANK:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/us_bank-icon.png',
  USAA: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/usaa-icon@2x.png',
  VANGUARD:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/vanguard-icon@2x.png',
  VSAC: 'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/vsac-icon@2x.png',
  WELLS_FARGO:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/wells_fargo-icon@2x.png',
  WEALTHFRONT:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/wealthfront@2x.png',

  GENERIC_BANK:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-bank.png',
  GENERIC_BANK_LIGHT:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-bank_light.png',
  GENERIC_CREDIT:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-credit.png',
  GENERIC_INVESTMENT:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-investment.png',
  GENERIC_LOAN:
    'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/provider-logos/generic-loan.png',
};

export const genericIconsByYodleeAccountType = {
  [YodleeAccountTypes.BANK]: CustomProviderIcons.GENERIC_BANK,
  [YodleeAccountTypes.CREDIT_CARD]: CustomProviderIcons.GENERIC_CREDIT,
  [YodleeAccountTypes.INVESTMENT]: CustomProviderIcons.GENERIC_INVESTMENT,
  [YodleeAccountTypes.LOAN]: CustomProviderIcons.GENERIC_LOAN,
};
